import React, { useContext } from "react";
import { Context } from "../../../Utility/ContextManager";
import { formatPhoneNumber } from "../../../Utility/index";
function PropertyManager() {
  const { propertyManagerInfo } = useContext(Context);
  return (
    <div className="details mx-2">
      <div className="row">
        <div className="col-xl-12">
          <p className="manager">
            <img src={require("../../../assets/images/user-icon.svg").default} />
            {`${propertyManagerInfo?.first_name}${
              propertyManagerInfo?.last_name ? ` ${propertyManagerInfo?.last_name}` : ""
            }`}
            {/* This line combines the first name and last name with a condition to present a space if no last name available */}
          </p>
        </div>
        <div className="col-xl-7">
          <p style={{ opacity: propertyManagerInfo?.phone ? 1 : 0.4 }}>
            <img src={require("../../../assets/images/phone-icon.svg").default} />
            {propertyManagerInfo?.phone && propertyManagerInfo?.phone !== " "
              ? formatPhoneNumber(propertyManagerInfo?.phone)
              : "Phone Number"}
          </p>
        </div>

        <div className="col-xl-5" style={{ marginLeft: "-5px" }}>
          <p style={{ opacity: 1 }}>
            <img src={require("../../../assets/images/send.svg").default} style={{ filter: "invert(0.3)" }} />
            (855) 793-3782
          </p>
        </div>

        <div className="col-12">
          <p style={{ opacity: propertyManagerInfo?.company_name ? 1 : 0.4 }}>
            <img src={require("../../../assets/images/monitor.svg").default} />{" "}
            {propertyManagerInfo?.company_name ? propertyManagerInfo?.company_name : "Company Name"}
          </p>
        </div>

        <div className="col-xl-7">
          <div className="d-flex align-items-start">
            <img src={require("../../../assets/images/email-icon.svg").default} />
            <p className="m-0" style={{ width: "90%" }}>
              {propertyManagerInfo?.email}
            </p>
          </div>
        </div>
        <div className="col-12" style={{ marginTop: "8px" }}>
          <p
            className="mt-1"
            style={{
              opacity: propertyManagerInfo?.address && propertyManagerInfo?.address !== " " ? 1 : 0.4,
            }}
          >
            <img src={require("../../../assets/images/address-icon.svg").default} />
            {propertyManagerInfo?.address && propertyManagerInfo?.address !== " "
              ? `${propertyManagerInfo?.address}, ${propertyManagerInfo?.city}, ${propertyManagerInfo?.state} ${propertyManagerInfo?.zipcode}`
              : "Address"}
          </p>
        </div>
      </div>
    </div>
  );
}

export default PropertyManager;
